// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"af2fd241","667":"43f6eb6e"}[chunkId] + ".chunk.js";
};